<div class="container mt-3">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Change Of Banking Details</span>
        </div>
    </div>
    <div class="card card_content">
        <div class="d-flex justify-content-start button-style mt-3">
            <button class="btn btn-primary mb-3" type="button" (click)="update()" matButton><i class="fa fa-add"></i>
                Update</button>
            <!-- <button class="btn btn-secondary mb-3 ml-3" type="button" (click)="Refresh()" matButton><i
                    class="fa fa-refresh"></i> Refresh</button> -->
                    <app-button (refreshClicked)="Refresh()" class="mb-3 ml-3"></app-button>

        </div>
        <div>
            <div class="table-responsive table-container mt-2 mb-4">
                <mat-table #table [dataSource]="dataSource" class="mat-table ">

                    <ng-container matColumnDef="CustomerNumber">
                        <mat-header-cell *matHeaderCellDef style="text-align: center;">Customer Number</mat-header-cell>
                        <mat-cell *matCellDef="let dataField" style="width: 5%;text-align: center;">
                            <p class="text-truncate txtalign"> {{dataField.customerReferenceNumber}}</p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="TimeStamp">
                        <mat-header-cell *matHeaderCellDef style="text-align: center;"> Time Stamp</mat-header-cell>
                        <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                            <p class="text-truncate txtalign">{{dataField.creationTs| date:'MM/dd/yyyy HH:mm:ss'}} </p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="DocumentProof">
                        <mat-header-cell *matHeaderCellDef style="text-align: center;">Document Proof</mat-header-cell>
                        <mat-cell *matCellDef="let dataField" style="width: 8%; text-align: center;">

                            <div class="text-truncate text-center" *ngIf="dataField.fileData">
                                <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-download"
                                    (click)="download(dataField.id)"></i>
                            </div>
                        </mat-cell>
                    </ng-container>



                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                    <mat-row *matRowDef="let row; columns: displayedColumns;  " matRipple>
                    </mat-row>
                </mat-table>
                <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                    <p>No data found</p>
                </div>
            </div>
            <div class="table_pagenation">
                <mat-paginator #paginator [length]="dataSource?.filteredData.length || 0" [pageIndex]="0"
                    [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>